import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getOrgId, setOrgId } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState(null); // null=checking, false=anon, object=session
  const [orgId, setOrg] = useState(getOrgId());

  const apply = useCallback((data) => {
    setState(data);
    const ids = (data.memberships || []).map((m) => m.id);
    if (!ids.includes(getOrgId())) {
      setOrgId(ids[0] || "");
      setOrg(ids[0] || "");
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      apply(r.data);
    } catch {
      setState(false);
    }
  }, [apply]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setOrgId("");
    setState(false);
  };

  const switchOrg = (id) => {
    setOrgId(id);
    setOrg(id);
  };

  const membership = state ? (state.memberships || []).find((m) => m.id === orgId) : null;
  return (
    <AuthCtx.Provider value={{ session: state, user: state?.user, apply, refresh, logout, orgId, switchOrg, membership,
      role: membership?.role, isSuper: state?.user?.platform_role === "super_admin" }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

const MANAGE = ["owner", "admin"];
const OPERATE = ["owner", "admin", "technician"];
export const can = {
  manage: (r) => MANAGE.includes(r),
  operate: (r) => OPERATE.includes(r),
  incident: (r) => [...OPERATE, "security_analyst"].includes(r),
  audit: (r) => [...MANAGE, "security_analyst", "auditor"].includes(r),
  export: (r) => r && r !== "customer_user",
};
